import _toConsumableArray from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { isAudioNode } from '../guards/audio-node';
import { isDelayNode } from '../guards/delay-node';
export var createDetectCycles = function createDetectCycles(audioParamAudioNodeStore, getAudioNodeConnections, getValueForKey) {
  return function detectCycles(chain, nextLink) {
    var audioNode = isAudioNode(nextLink) ? nextLink : getValueForKey(audioParamAudioNodeStore, nextLink);

    if (isDelayNode(audioNode)) {
      return [];
    }

    if (chain[0] === audioNode) {
      return [chain];
    }

    if (chain.includes(audioNode)) {
      return [];
    }

    var _getAudioNodeConnecti = getAudioNodeConnections(audioNode),
        outputs = _getAudioNodeConnecti.outputs;

    return Array.from(outputs).map(function (outputConnection) {
      return detectCycles([].concat(_toConsumableArray(chain), [audioNode]), outputConnection[0]);
    }).reduce(function (mergedCycles, nestedCycles) {
      return mergedCycles.concat(nestedCycles);
    }, []);
  };
};